import React from 'react';

const DeleteAccountSection = ({
  deleteConfirm,
  reauthPassword,
  onDelete,
  onCancel,
  onConfirmStart,
  onPasswordChange,
}) => (
  <div className="rounded-xl border border-red-200 bg-white overflow-hidden">
    <div className="px-6 py-5">
      <div className="flex items-center gap-3 mb-1">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
        <h3 className="text-sm font-semibold text-gray-900">Delete Account</h3>
      </div>
      <p className="text-sm text-gray-500 ml-8">
        Permanently remove your account and all associated data. This action cannot be undone.
      </p>

      {deleteConfirm ? (
        <div className="mt-4 ml-8 space-y-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Confirm your password</label>
            <input
              type="password"
              value={reauthPassword}
              onChange={onPasswordChange}
              className="w-full max-w-xs rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-red-400 focus:border-red-400 focus:outline-none transition-shadow"
              placeholder="Enter password"
            />
          </div>
          <div className="flex flex-wrap gap-3">
            <button
              onClick={onDelete}
              className="px-4 py-2 rounded-lg bg-red-600 text-white text-sm font-medium hover:bg-red-700 transition-colors"
            >
              Delete Account
            </button>
            <button
              onClick={onCancel}
              className="px-4 py-2 rounded-lg bg-white border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-4 ml-8">
          <button
            onClick={onConfirmStart}
            className="px-4 py-2 rounded-lg border border-red-300 text-sm font-medium text-red-600 hover:bg-red-50 transition-colors"
          >
            Delete Account…
          </button>
        </div>
      )}
    </div>
  </div>
);

export default DeleteAccountSection;
